
import { defineComponent, ref, onMounted, watch } from 'vue';
import SubjectCard from './SubjectCard.vue';
import { MaterialHistory, MaterialTree } from '../../../types';
import Materials from '../../../boot/services/Materials';
import sortBy from 'lodash.sortby';
import { useRoute } from 'vue-router';

const METHODOLOGY_PATH = 'metodologia';
const MATERIAL_PATH = 'material';

type orderItem = {
  label: string;
  value: string;
  reverse: boolean;
};

export default defineComponent({
  name: 'SubjectList',
  components: {
    SubjectCard,
  },
  props: {
    subject: {
      type: String,
    },
  },
  setup(props) {
    const route = useRoute();
    const loading = ref(false);
    const searchSubjects = ref<string>();
    const filteredTree = ref<MaterialTree[]>();
    const materialTree = ref<MaterialTree[]>();
    const orderOptions = ref<orderItem[]>([
      { label: 'A-Z', value: 'title', reverse: false },
      { label: 'Z-A', value: 'title', reverse: true },
    ]);
    const orderOption = ref<orderItem>({
      label: 'A-Z',
      value: 'title',
      reverse: false,
    });
    const history = ref<MaterialHistory[]>();

    const fetchMaterialTree = async () => {
      loading.value = true;
      materialTree.value = await getMaterialTree();
      loading.value = false;
    };

    onMounted(async () => {
      void (await fetchMaterialTree());
      searchSubjects.value = props.subject;
    });

    watch(
      () => materialTree.value,
      () => {
        filteredTree.value = materialTree.value;
      }
    );

    watch(
      () => orderOption.value,
      () => {
        if (filteredTree.value) {
          const { value, reverse } = orderOption.value;
          const sorted = sortBy(filteredTree.value, [value]);
          filteredTree.value = reverse ? sorted.reverse() : sorted;
        }
      }
    );

    watch(
      () => searchSubjects.value,
      () => {
        if (materialTree.value && materialTree.value.length) {
          filteredTree.value = materialTree.value.filter((tree) => {
            const search = searchSubjects.value
              ? searchSubjects.value.toLowerCase()
              : '';
            return tree.subject.toLowerCase().includes(search);
          });
        }
      }
    );

    const getMaterialTree = async () => {
      let tree: MaterialTree[] | undefined;
      if (!!route.path.split('/').find((path) => path === MATERIAL_PATH)) {
        tree = await Materials.fetchMaterialBySubjects([]);
      } else if (
        !!route.path.split('/').find((path) => path === METHODOLOGY_PATH)
      ) {
        tree = await Materials.fetchMaterialByTag();
      }
      return tree;
    };

    return {
      materialTree,
      filteredTree,
      searchSubjects,
      orderOptions,
      orderOption,
      history,
      loading,
      fetchMaterialTree,
    };
  },
});
